import Proptypes from 'prop-types';

export const FileObjectDefinition = Proptypes.shape({
  _id: Proptypes.string.isRequired,
  name: Proptypes.string.isRequired,
  url: Proptypes.string,
  _new: Proptypes.bool,
});
